import React, { useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import TextStyle from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import Color from '@tiptap/extension-color';
import { TextAlign } from '@tiptap/extension-text-align';
import { Link } from '@tiptap/extension-link';
import Superscript from '@tiptap/extension-superscript';
import Subscript from '@tiptap/extension-subscript';
import ListItem from '@tiptap/extension-list-item';
import MenuBar from './MenuBar';
import { WidgetContext } from '@/WidgetContextProvider';
import './Editor.scss';

const CustomListItem = ListItem.extend({
	addGlobalAttributes() {
		return [
			{
				types: ['listItem'],
				attributes: {
					style: {
						default: '',
					},
				},
			},
		];
	},
});

const Editor = props => {
	const { value, onChange, theme, widgetToUpdate, widgets, preview } = props;
	const { previewerRef } = useContext(WidgetContext);

	const editor = useEditor({
		extensions: [
			StarterKit.configure({
				heading: {
					levels: [1, 2, 3],
				},
				listItem: false,
			}),
			TextStyle,
			Underline,
			CustomListItem,
			Color,
			Superscript,
			Subscript,
			TextAlign.configure({
				types: ['paragraph', 'heading'],
			}),
			Link.configure({
				openOnClick: false,
			}),
		],
		content: value,
		onUpdate: ({ editor }) => onChange(editor.view.dom.innerHTML), // preserves empty paragraphs as opposed to editor.getHTML()
	});

	useEffect(() => {
		if (editor && value && value !== editor.view.dom.innerHTML) {
			// removes extra br tag tiptap adds https://github.com/ueberdosis/tiptap/issues/1500
			let cleanedHtml = value.replace(/<br\s*class=["']ProseMirror-trailingBreak["']\s*\/?>/g, '');
			editor.commands.setContent(cleanedHtml);
		}
	}, [editor, value]);
	const containerHeight = previewerRef?.current?.offsetHeight || 0;

	const background =
		theme && theme.background_src
			? {
					backgroundImage: `url(${theme.background_src})`,
					backgroundSize: `auto ${containerHeight}px`,
			  }
			: { backgroundColor: theme.background_color || '#FFFFFF' };

	//approximate background position by widgetToUpdate position
	const position = widgets.findIndex(widget => widget.id === widgetToUpdate.id);
	const phoneSize = containerHeight / 8;
	const tabletSize = containerHeight / 10;
	const desktopSize = containerHeight / 12;

	const sizeToMove =
		preview === 'tablet' ? tabletSize : preview === 'phone' ? phoneSize : desktopSize;
	let backgroundPositionOffset = position * sizeToMove;

	backgroundPositionOffset = Math.min(backgroundPositionOffset, containerHeight - sizeToMove);
	const backgroundPosition = `50% -${backgroundPositionOffset}px`;

	return editor ? (
		<div className="Editor">
			{/* {editor.isFocused && <MenuBar editor={editor} />} */}
			<MenuBar editor={editor} />

			<EditorContent
				editor={editor}
				className="tiptap-container"
				style={{ ...background, backgroundPosition }}
			/>
		</div>
	) : null;
};

const msp = ({ widgets }) => ({
	widgets,
});

export default connect(msp, null)(Editor);
